/** Fallback legado: defensorias já habilitadas sem data gravada. */
export const DATA_INICIAL_RELATORIOS_ATIVIDADES = { mes: 1, ano: 2026 } as const;

export type PeriodoMesAno = { mes: number; ano: number };

/**
 * Primeiro período de relatório elegível a notificação após a habilitação.
 * Usa o mês civil imediatamente anterior à data (ciclo de prazo vigente ao ativar).
 * Sem data: mantém o comportamento legado (jan/2026).
 */
export function primeiroPeriodoRelatorioAposHabilitacao(
  habilitadoEm: Date | string | null | undefined,
): PeriodoMesAno {
  if (!habilitadoEm) {
    return {
      mes: DATA_INICIAL_RELATORIOS_ATIVIDADES.mes,
      ano: DATA_INICIAL_RELATORIOS_ATIVIDADES.ano,
    };
  }

  const d = habilitadoEm instanceof Date ? habilitadoEm : new Date(habilitadoEm);
  if (Number.isNaN(d.getTime())) {
    return {
      mes: DATA_INICIAL_RELATORIOS_ATIVIDADES.mes,
      ano: DATA_INICIAL_RELATORIOS_ATIVIDADES.ano,
    };
  }

  const mesHabilitacao = d.getMonth() + 1;
  const anoHabilitacao = d.getFullYear();
  if (mesHabilitacao === 1) {
    return { mes: 12, ano: anoHabilitacao - 1 };
  }
  return { mes: mesHabilitacao - 1, ano: anoHabilitacao };
}

export function periodoMaiorOuIgual(a: PeriodoMesAno, b: PeriodoMesAno): boolean {
  return a.ano > b.ano || (a.ano === b.ano && a.mes >= b.mes);
}

/**
 * Menor data inicial de notificação entre as defensorias habilitadas das lotações.
 * Sem defensoria habilitada: retorna período futuro (não gera alertas de meses vazios).
 */
export function obterDataInicialNotificacoesRelatorios(
  lotacoes: Array<{
    defensoria?: {
      relatoriosAtividadesHabilitado?: boolean;
      relatoriosAtividadesHabilitadoEm?: string | Date | null;
      [key: string]: unknown;
    } | null;
  } | null | undefined>,
): PeriodoMesAno {
  const habilitadas = (lotacoes ?? []).filter(
    (l) => l?.defensoria?.relatoriosAtividadesHabilitado === true,
  );

  if (habilitadas.length === 0) {
    return { mes: 12, ano: 9999 };
  }

  let menor: PeriodoMesAno | null = null;
  for (const lotacao of habilitadas) {
    const periodo = primeiroPeriodoRelatorioAposHabilitacao(
      lotacao?.defensoria?.relatoriosAtividadesHabilitadoEm,
    );
    if (!menor || periodo.ano < menor.ano || (periodo.ano === menor.ano && periodo.mes < menor.mes)) {
      menor = periodo;
    }
  }

  return menor ?? {
    mes: DATA_INICIAL_RELATORIOS_ATIVIDADES.mes,
    ano: DATA_INICIAL_RELATORIOS_ATIVIDADES.ano,
  };
}
